import * as React from "react";

import { Checkbox, Stack } from "@mantine/core";
import { Role } from "../../../types/persons/Role";

interface RoleFormProps {
  role?: Role;
  onChange: Function;
}

const RoleForm: React.FunctionComponent<RoleFormProps> = ({
  role,
  onChange,
}) => {
  const roleOrDefault = role || 0;

  const addOrRemoveRole = (checked: boolean, value: Role) => {
    const newRole = checked
      ? Role.addRole(roleOrDefault, value)
      : Role.removeRole(roleOrDefault, value);
    onChange(newRole);
  };

  const roles = Role.getAllRoles().map((k) => (
    <Stack gap="sm" key={k}>
      <Checkbox
        checked={Role.hasRole(roleOrDefault, k)}
        onChange={(event) => addOrRemoveRole(event.currentTarget.checked, k)}
        label={Role.toString(k).toUpperCase()}
        size="sm"
      />
    </Stack>
  ));

  return <div>{roles}</div>;
};

export default RoleForm;
